import { useEffect } from 'react';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';
import { MessageBus } from '@app-velocity/message-bus';

const messageBus = new MessageBus('teams');

export const usePaidTeamAvailableNotification = (
  activeTeam: TCurrentUserTeamDto | null,
  availableTeams: TCurrentUserTeamDto[],
  teamIdParam?: string
) => {
  useEffect(() => {
    // team param needs to be available - route needs to be stabilized first
    if (
      !teamIdParam ||
      !activeTeam ||
      activeTeam.subscriptionTier !== 'FREE' ||
      availableTeams.length === 0
    )
      return;

    const firstNotFreeTeam = availableTeams?.find(
      (t) => t.subscriptionTier !== 'FREE'
    );

    if (!firstNotFreeTeam) return;

    const alreadyDisplayedOnStartUp = localStorage.getItem(
      'available-team-notification'
    );

    if (alreadyDisplayedOnStartUp) return;

    messageBus.publish('modal:paid-team-available:open', {
      team: firstNotFreeTeam,
      // important to clear callback from other call
      onCloseModalCallback: null,
    });

    localStorage.setItem(
      'available-team-notification',
      new Date().toISOString()
    );
  }, [activeTeam, availableTeams, teamIdParam]);
};
